export class LoanClass {
    id:number
    Num:number
    date:Date
    Age:number
    dateBorn:Date

}
